import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-center px-6 py-16 text-center font-League_Spartan">

      {/* Icon — broken/empty page */}
      <div className="mb-10">
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="8" y="20" width="64" height="46" rx="5"
            stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
          <path d="M8 30 L72 30" stroke="rgba(255,255,255,0.15)" strokeWidth="1.5" />
          <circle cx="18" cy="25" r="2" fill="rgba(255,255,255,0.2)" />
          <circle cx="26" cy="25" r="2" fill="rgba(255,255,255,0.2)" />
          <circle cx="34" cy="25" r="2" fill="rgba(255,255,255,0.2)" />
          <path d="M22 42 L58 42" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" />
          <path d="M28 50 L52 50" stroke="#FFF528" strokeWidth="2" strokeLinecap="round" />
          <path d="M22 58 L44 58" stroke="rgba(255,255,255,0.12)" strokeWidth="1.5" strokeLinecap="round" />
          <circle cx="62" cy="58" r="10" fill="#0a0a0a" stroke="#FFF528" strokeWidth="1.5" />
          <path d="M62 53 L62 59" stroke="#FFF528" strokeWidth="2" strokeLinecap="round" />
          <circle cx="62" cy="62" r="1.2" fill="#FFF528" />
        </svg>
      </div>

      {/* 404 */}
      <h1 className="text-[clamp(64px,16vw,108px)] font-bold text-[#FFF528] leading-none tracking-tighter mb-4">
        404
      </h1>

      {/* Heading */}
      <p className="text-xl sm:text-2xl font-semibold text-white mb-3 tracking-tight">
        Page not found
      </p>

      {/* Message */}
      <p className="text-sm text-gray-600 max-w-xs sm:max-w-sm leading-relaxed mb-10">
        The page you're looking for doesn't exist or has been moved.
        Please check the URL or navigate back.
      </p>

      {/* Single CTA */}
      <button
        onClick={() => navigate(-1)}
        className="px-8 py-3 bg-[#FFF528] text-black text-sm font-semibold rounded-lg
          hover:brightness-105 active:scale-[0.97] transition-all duration-150"
      >
        Go back
      </button>

      {/* Footer rule */}
      <div className="flex items-center gap-3 mt-14">
 
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block"></span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block"></span>
        <span className="w-1.5 h-1.5 rounded-full bg-[#FFF528] animate-pulse inline-block"></span>
        
      </div>

    </div>
  );
};

export default NotFound;